import React from 'react';
import StyledProgressbar from './StyledProgressbar';
import 'react-circular-progressbar/dist/styles.css';

const style = {
  width: 60,
  height: 60,
};
const ProgressBar = ({ percentage, text, progressBarColor }: any) => (
  <div style={style}>
    <StyledProgressbar percentage={percentage} text={text} color={progressBarColor} />
  </div>
);

export default ProgressBar;
